import { useQuery } from "@tanstack/react-query";
import {
	GetDatasetSchemaQuery,
	GetDatasetSchemaQueryVariables,
} from "~map-tools/types/__generated/gql/graphql";
import { graphierQLNextClient } from "utils";

const query = /* GraphQL */ `
	query GetDatasetSchema($tableName: String!) {
		getDatasetSchema(tableName: $tableName) {
			tableName
			columns {
				name
				type
				nullable
				uniqueConstraint
				hasIndex
				sampleValues
				properties
				required
				minValue
				maxValue
			}
		}
	}
`;

export type GetDatasetSchemaVariables = GetDatasetSchemaQueryVariables;
export type GetDatasetSchemaResults = GetDatasetSchemaQuery["getDatasetSchema"];

export const getDatasetSchemaQueryKey = (
	variables: GetDatasetSchemaVariables,
) => ["getDatasetSchema", variables];

export const getDatasetSchemaQueryFn = async (
	variables: GetDatasetSchemaVariables,
) => {
	return graphierQLNextClient<GetDatasetSchemaQuery, GetDatasetSchemaVariables>(
		{
			query,
			variables,
		},
	).then((res) => res.getDatasetSchema);
};

export const useGetDatasetSchema = (variables: GetDatasetSchemaVariables) => {
	return useQuery({
		enabled: !!variables.tableName,
		queryKey: getDatasetSchemaQueryKey(variables),
		queryFn: () => getDatasetSchemaQueryFn(variables),
	});
};
